import { staffTheadData } from '../../../data/admin-data';
import { Role, Status } from '../../../types/masterData';
import { StaffData } from '../../../types/user'
import ErrorMessage from '../../ui/ErrorMessage';
import Loading from '../../ui/Loading';

interface StaffTBodyProps {
    staff: StaffData[];
    handleClickedUpdate: (staff: StaffData, role: string) => void
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean
    roles: Role[];
    status: Status[];
}

export default function StaffTBody({ roles, status, staff, isLoading, isEmpty, errorMessage, isError, handleClickedUpdate }: StaffTBodyProps) {
    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={staffTheadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={staffTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={staffTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                staff?.map((staff, index) => {
                    const rolesAPI: Role | undefined = roles.find(role => role.roleId === staff.roleId);
                    const userRole = rolesAPI?.role
                    const statusesAPI: Status | undefined = status.find(stat => stat.statusId === staff.statusId);
                    const userStatus = statusesAPI?.status
                    return (
                        <tr 
                            // onClick={() => onClick(staff)}
                            key={staff.staffID} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {`${staff.firstName} ${
                                        staff.middleInitial ? staff.middleInitial + ". " : ""
                                    }${staff.lastName}`}
                                </div>
                            </th>
                            <th className="px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {staff.email}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <span
                                    className={`inline-flex rounded px-2 py-0.5 text-xs font-medium ${
                                        userStatus?.toLowerCase() === "active"
                                            ? "bg-green-100 text-green-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                >
                                    {userStatus}
                                </span>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {userRole}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    <button
                                        onClick={() => handleClickedUpdate(staff, userRole ?? "")}
                                        className="text-xs px-4 py-1.5 rounded transition text-cbColor"
                                    >
                                        Edit
                                    </button>
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
